import React from 'react'
import Stack from '@mui/material/Stack'
import EditableTextField from '../../../common/fields/editableTextField'
import OutlinedFieldFormik from '../../../formik/fields/outlinedFieldFormik'
import DatePickerFieldFormik from '../../../formik/fields/datePickerFieldFormik'
import SectionForm from '../../../common/sectionForm'
import useMediaQuery from '@mui/material/useMediaQuery'
import { getDayAndMonthNameYear } from '../../../../utils'

interface Props {
  formik: any
}

const AdditionalInformationForm = ({ formik }: Props) => {
  const isMobile = useMediaQuery('(max-width:800px)')

  return (
    <SectionForm title='Informations complémentaires'>
      <Stack direction={isMobile ? 'column' : 'row'} spacing='24px' sx={{ mb: '24px' }}>
        <EditableTextField
          label='Date de naissance'
          sx={{ width: isMobile ? '100%' : '318px' }}
          value={formik.values.date_of_birth ? getDayAndMonthNameYear(formik.values.date_of_birth) : ''}
        >
          <DatePickerFieldFormik name='date_of_birth' />
        </EditableTextField>
        <EditableTextField
          label='4 derniers chiffres du NAS'
          sx={{ width: isMobile ? '100%' : '318px', mt: isMobile ? '24px' : 0 }}
          value={formik.values.sin_last_four || ''}
        >
          <OutlinedFieldFormik 
            name='sin_last_four' 
            placeholder='XXXX'
            inputProps={{
              maxLength: 4,
              pattern: '[0-9]*',
            }}
          />
        </EditableTextField>
      </Stack>
    </SectionForm>
  )
}

export default AdditionalInformationForm
